"use client";

import { useTranslation } from "@/i18n";
import type { Language } from "@/i18n/types";
import { cn } from "@/lib/utils";

const LANGUAGES: { code: Language; label: string }[] = [
    { code: "en", label: "EN" },
    { code: "fr", label: "FR" },
];

export function LanguageSwitcher({ className }: { className?: string }) {
    const { lang, setLang } = useTranslation();

    return (
        <div
            className={cn("flex items-center gap-0.5", className)}
            role="group"
            aria-label="Language selection"
        >
            {LANGUAGES.map(({ code, label }, i) => (
                <button
                    key={code}
                    onClick={() => setLang(code)}
                    aria-pressed={lang === code}
                    aria-label={`Switch to ${code === "en" ? "English" : "French"}`}
                    className={cn(
                        "text-[11px] font-semibold uppercase tracking-wider px-1.5 py-0.5 transition-colors cursor-pointer",
                        lang === code
                            ? "text-mars"
                            : "text-text-muted hover:text-text-secondary",
                        i < LANGUAGES.length - 1 && "border-r border-border pr-1.5"
                    )}
                >
                    {label}
                </button>
            ))}
        </div>
    );
}
